// Laufzeitkonfiguration.
//
// REACT_APP_* wird von Create React App fest in das Bundle kompiliert und taugt
// deshalb nicht zum spaeteren Ein-/Ausschalten von Funktionen. nginx erzeugt
// stattdessen aus den Umgebungsvariablen eine /config.json (siehe
// nginx/templates/default.conf.template) - ein Umschalten braucht damit nur
// einen Container-Neustart, keinen neuen Build.

const TRUTHY = new Set(['true', '1', 'yes', 'on', 'ja']);

const isTruthy = (value) => TRUTHY.has(String(value).trim().toLowerCase());

/** Fallback, wenn /config.json nicht gelesen werden kann. */
function fallbackChatEnabled() {
    // In der Entwicklung gibt es kein nginx - dort standardmaessig an, per
    // REACT_APP_CHAT_ENABLED=false abschaltbar.
    if (process.env.NODE_ENV !== 'production') {
        return process.env.REACT_APP_CHAT_ENABLED !== 'false';
    }
    // In der Produktion lieferte nginx keine verwertbare Antwort. Dann lieber
    // ausblenden als einen kaputten Chat zeigen.
    return false;
}

export default async function loadRuntimeConfig() {
    try {
        const response = await fetch('/config.json', {
            headers: { Accept: 'application/json' },
            cache: 'no-store',
        });
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }
        const data = await response.json();
        return { chatEnabled: isTruthy(data.chatEnabled) };
    } catch (error) {
        const chatEnabled = fallbackChatEnabled();
        console.warn(
            `[config] /config.json nicht lesbar (${error.message}) – Chat ${
                chatEnabled ? 'aktiv' : 'ausgeblendet'
            }.`
        );
        return { chatEnabled };
    }
}
